import React from 'react';

/**
 * SafeText component - safely renders text content, preventing React object rendering errors
 * @param {any} children - Content to render
 * @param {string} fallback - Fallback text if content cannot be rendered
 * @returns {React.Element} - Safe text element
 */
const SafeText = ({ children, fallback = 'N/A' }) => {
  const safeRender = (content) => {
    if (content === null || content === undefined) {
      return fallback;
    }
    
    if (typeof content === 'string' || typeof content === 'number' || typeof content === 'boolean') {
      return String(content);
    }
    
    if (typeof content === 'object') {
      console.warn('SafeText: Attempted to render object directly:', content);
      
      // Try to extract meaningful information from the object
      if (content.email) {
        return String(content.email);
      }
      if (content.name) {
        return String(content.name);
      }
      if (content.displayName) {
        return String(content.displayName);
      }
      if (content.companyName) {
        return String(content.companyName);
      }
      
      return fallback;
    }
    
    return String(content);
  };

  return <>{safeRender(children)}</>;
};

export default SafeText; 